import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { holdStill } from './ui/holdStill.js';
import './styles.css';

// No pinch, no page left scrolled: the phone's page acts like an app.
holdStill();

// We got here, so the bundle loaded. Let a future stale deploy recover in its turn.
try {
  sessionStorage.removeItem('cc-stale-recovery');
} catch {
  /* private mode; the latch simply never sets either */
}

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

// Installable to the home screen, so a locked phone survives the evening.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // No service worker is not a reason to miss the voyage.
    });
  });
}
